<template>
  <div>
    <span class="fontsPeque" style="color: #53BACA; font-weight: 500; margin-left: 14px;">Productos</span>


    <div style=" margin-left: 14px;">
      <b-row >
        <b-col cols="4">
          <b-card style="height: 100%;">
            <b-row style="margin-top: -16px;">
              <b-col cols="10">
                <span class="fontsPeque" style="font-weight: 500">Lista de productos</span>
              </b-col>
              <b-col cols="2">
                <em class="blue_plus" style="cursor: pointer;"
                    v-b-tooltip.hover.topright.v-light
                    title="Crear nuevo producto"
                    @click="mostrarTarjetaConfigProductos()"
                />
              </b-col>
            </b-row>

            <div v-for="(producto, index) in listaProductos" :key="index">
              <div style="border: 1px solid #D4EDF1; background-color: #D4EDF1; border-radius: 10px; height: 28px; cursor: pointer;"
                   class="mt-2" @click="seleccionarProducto(producto)">
                <b-row style="padding: 4px;">

                  <b-col cols="10" class="text-left fontsPeque ml-2" style="margin-top: 4px; color: #494949">
                    <span> {{ producto.nombreProducto }} </span>
                  </b-col>
                </b-row>

              </div>
            </div>

          </b-card>
        </b-col>

        <b-col cols="8">
          <div v-if="tarjeta">
            <div v-if="productoSeleccionado.idProductoLaboratorio !== null " class="d-inline-flex">
              <span class="fontsPeque ml-2" style="color: rgb(83, 186, 202); font-weight: 600" >Edición de producto</span>
              <em class= "trash_svg ml-2" style="cursor:pointer;width: 18px;"
                  v-b-tooltip.hover.topright.v-light
                  title="Quitar tratamiento"
                  @click="quitarProducto(productoSeleccionado.idProductoLaboratorio)"
              ></em>
            </div>
            <span class="fontsPeque" style="color: rgb(83, 186, 202); font-weight: 600" v-else > Agregar un nuevo producto</span>

            <b-row>
              <b-col cols="8"></b-col>
              <b-col cols="4">
                <div class="d-flex" >
                  <div class="d-flex justify-content-center align-items-center" style="padding-left: 2%; padding-right: 2%; height: 2.5em; cursor: pointer"
                       @click="opcionTabSeleccionada = index"
                       :class="opcionTabSeleccionada === index ? 'tabOpciones seleccionado' : 'tabOpciones'"
                       v-for="(opt, index) in opciones" :key="index" :title="opt.nombre">
                    <p class="mt-3" :class="opcionTabSeleccionada === index ? 'tabTxtSeleccionado' : 'tabTxt'">
                      {{ opt.nombre }}
                    </p>
                  </div>
                </div>
              </b-col>
            </b-row>

            <div v-if="opcionTabSeleccionada === 0 && this.productoSeleccionado != null" class="mt-3">
              <div >
                <b-row >
                <b-col>
                  <span class="fontsPeque">Nombre del producto <span style="color: red">*</span></span>
                  <b-form-input
                      class="tamanioCampo"
                      placeholder="Ingresa el nombre del laboratorio"
                      v-model="productoSeleccionado.nombreProducto"
                      type="text"
                      :state="productoSeleccionado.nombreProducto != null && productoSeleccionado.nombreProducto !== '' "
                      required
                  ></b-form-input>
                  <br/>
                  <span class="fontsPeque">Precio <span style="color: red">*</span></span>
                  <b-form-input
                      class="tamanioCampo"
                      placeholder="0.00"
                      type="text"
                      inputmode="decimal"
                      v-model="productoSeleccionado.precio"
                      required
                      @keydown="bloquearMasDeDosDecimales"
                      @paste.prevent="pegarDecimal2"
                      @blur="formatear2Decimales"
                      :state="productoSeleccionado.precio != null && productoSeleccionado.precio !== '' "
                  />
                  <br/>
                  <span class="fontsPeque">Tiempo de producción urgente (en días hábiles) <span style="color: red">*</span></span>
                  <b-form-input
                      class="tamanioCampo"
                      placeholder="0"
                      v-model="productoSeleccionado.tiempoUrgente"
                      type="number"
                      min="1"
                      :state="productoSeleccionado.tiempoUrgente != null && productoSeleccionado.tiempoUrgente !== '' "
                      @keydown="filterJustNumber($event)"
                      required
                  ></b-form-input>
                </b-col>
                <b-col>
                  <span class="fontsPeque">Descripción del producto <span style="color: red">*</span></span>
                  <b-form-input
                      class="tamanioCampo"
                      placeholder="Ingresa la descripción del laboratorio"
                      v-model="productoSeleccionado.descProducto"
                      type="text"
                      :state="productoSeleccionado.descProducto != null && productoSeleccionado.descProducto !== '' "
                      required
                  ></b-form-input>
                  <br/>
                  <span class="fontsPeque">Tiempo de producción normal (en días hábiles) <span style="color: red">*</span></span>
                  <b-form-input
                      class="tamanioCampo"
                      placeholder="0"
                      v-model="productoSeleccionado.tiempoNormal"
                      type="number"
                      :state="productoSeleccionado.tiempoNormal != null && productoSeleccionado.tiempoNormal !== '' "
                      required
                      min="1"
                      @keydown="filterJustNumber($event)"
                  ></b-form-input>
                </b-col>
              </b-row>
              </div>


            </div>

            <div v-if="opcionTabSeleccionada === 1 " >
              <span style="color: #32919F; font-size: 11px"> Tratamientos relacionados al producto </span>
              <div class="d-flex justify-content-center w-100 mt-2" >
                <div class="busqueda d-flex mt-2" style="width: 50%; margin-top: 10px;" >
                  <b-form-input class="input-filter"
                                v-model="busquedaTratamiento"
                                placeholder="Búsqueda de tratamientos por nombre o id" type="text"
                                @input="buscarTratamientos()"
                                @keydown.enter.prevent="buscarTratamientos()"
                                :disabled="productoSeleccionado.idTratamiento !== null"
                  >
                  </b-form-input>
                  <b-button class="btn-extra-small" variant="info" pill>
                    <span ><em class="buscar_svg" style="margin-top: 3px; height: 13px; " @click="buscarTratamientos()"></em></span>
                  </b-button>
                </div>
              </div>
              <div class="d-flex justify-content-center w-100 mt-2" style="overflow-y: scroll; max-height: 200px; " v-if="filteredTratamientos.length > 0">
                <table id="productosLab" class="w-full text-center fontsPeque" style="width: 90%"  aria-label="tabla tratamientos">
                  <thead>
                  <tr>
                    <th class="border-b p-2">ID tratamiento</th>
                    <th class="border-b p-2">Nombre tratamiento</th>
                    <th class="border-b p-2">Especialidad</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(tratamiento, index) in filteredTratamientos" :key="index"  @click="seleccionarTratamiento(tratamiento)" style="cursor: pointer;">
                    <td class="border-b p-2">{{ tratamiento.idTratamiento }}</td>
                    <td class="border-b p-2">{{ tratamiento.nombreTratamiento }}</td>
                    <td class="border-b p-2">{{ tratamiento.especialidad }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <div v-if="productoSeleccionado.idTratamiento  != null" class="mt-4">
                <b-card>
                  <div style="position: relative; margin-top: -18px;">
                    <b-row>
                      <b-col cols="11"><span class="fontsPeque" style="font-weight: 600">Tratamiento relacionado</span></b-col>
                      <b-col cols="1">
                        <em class= "trash_svg" style="cursor:pointer"
                            v-b-tooltip.hover.topright.v-light
                            title="Quitar tratamiento"
                            @click="quitarTratamiento()"
                        ></em>
                      </b-col>
                    </b-row>


                    <b-row >
                    <b-col style="display: inline-grid;">
                      <span class="fontsPeque" style="font-weight: 500">ID:</span>
                      <span class="fontsPeque">{{productoSeleccionado.idTratamiento}}</span>
                    </b-col>
                    <b-col style="display: inline-grid;">
                      <span class="fontsPeque" style="font-weight: 500">Nombre tratamiento: </span>
                      <span class="fontsPeque"> {{productoSeleccionado.nombreTratamiento}} </span>
                    </b-col>
                  </b-row>
                  </div>
                </b-card>
              </div>

            </div>


          </div>

        </b-col>
      </b-row>
    </div>
    <div class="text-center mt-4">
      <b-button variant="outline-primary" pill size="sm" @click="guardarProductos()"
                :disabled="listaProductos.length === 0 || tieneValoresNulos"
      >
        <span>Guardar Producto</span>
        <b-spinner v-if="guardando" variant="info" small/>
      </b-button>
    </div>

  </div>
</template>
<script>
export default {
  name: "ProductosLab",
  components: {},
  props:{
    listaTratamientos: Array,
    idLaboratorio: Number,
    editar: Boolean,
    productosLab: Array,
  },
  data: () => ({
    busquedaTratamiento: null,
   // tabSeleccionada: 1,
    opcionTabSeleccionada: 0,
    tabs: null,

    opciones: [
      {nombre: "General"},
      {nombre: "Tratamientos"},
    ],
    listaProductos: [],

    productoSeleccionado: null,
    tarjeta: false,
    filter: '',
    filteredTratamientos: [],
    guardando: false,
  }),
  computed: {
    tieneValoresNulos() {
      return this.listaProductos.some(obj => {
        return Object.entries(obj).some(([key, value]) => {
          // Excluir 'idProducto' de la comprobación de valores nulos
          return key !== 'idProductoLaboratorio' && value === null;
        });
      });
    }
  },
  created(){
    if (this.editar){
      this.listaProductos = this.productosLab;
    }
  },
  methods: {
    quitarProducto(id){
      this.$swal.fire({
        icon: "warning",
        html: '<p><strong>¿Estás seguro?</strong></p>',
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        showLoaderOnConfirm: true,
        confirmButtonColor: "#EEBA6D",
        preConfirm: () => {
          this.guardando = true
          const params = {
            idClinica: id
          }
          this.$http.post(this.$api + "labs/inactivarProducto", params)
              .then((resp) => {
                console.log(resp)
              }).finally(() =>{
                  this.$emit('obtenerLaboratorios');
                })
        }
      })
    },
    quitarTratamiento(){
      this.productoSeleccionado.idTratamiento = null;
      this.productoSeleccionado.nombreTratamiento = null;
    },
    seleccionarProducto(item){
      this.productoSeleccionado = item;
      this.opcionTabSeleccionada = 0;
      this.tarjeta = true;
    },
    guardarProductos(){
      const guardar = {
        idLaboratorio: this.idLaboratorio,
        productos: this.listaProductos
      }
      if (this.guardando){
        return;
      }

      this.$swal.fire({
        icon: "warning",
        html: '<p><strong>¿Estás seguro?</strong></p>',
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        showLoaderOnConfirm: true,
        confirmButtonColor: "#EEBA6D",
        preConfirm: () => {
          this.guardando = true
          this.$http.post(this.$api + "labs/guardar/laboratorioProductos", guardar)
              .then((resp) => {
                if (resp.data.data) {
                  this.guardando = false
                  this.$swal({
                    icon: "success",
                    text: "Se guardó la información del laboratorio correctamente",
                    confirmButtonText: "OK",
                    confirmButtonColor: "#0e6ba9",
                    onClose: () => {
                      this.$emit('obtenerLaboratorios', 3);
                    }
                  })
                }
              })
        }
      })
    },


    buscarTratamientos(){
      if (this.busquedaTratamiento !== ''){
        this.filteredTratamientos = this.listaTratamientos.filter(trt => trt.nombreTratamiento.toLowerCase().includes(this.busquedaTratamiento.toLowerCase())
            || String(trt.idTratamiento).includes(this.busquedaTratamiento)
        );
      }else{
        this.filteredTratamientos = []
      }
    },
    seleccionarTratamiento(tratamiento) {
      this.filteredTratamientos = [];
      this.productoSeleccionado.idTratamiento = tratamiento.idTratamiento
      this.productoSeleccionado.nombreTratamiento = tratamiento.nombreTratamiento
      this.filter = '';
    },
    mostrarTarjetaConfigProductos(){
      this.tarjeta = true;
      const nuevoProducto = {
        nombreProducto: null,
        precio: null,
        tiempoUrgente: null,
        descProducto: null,
        tiempoNormal: null,
        idTratamiento: null,
        nombreTratamiento: null,
        idProductoLaboratorio: null,
      //  tratamientoSeleccionado: null
      };
      this.listaProductos.unshift(JSON.parse(JSON.stringify( nuevoProducto)));

      this.productoSeleccionado = this.listaProductos[0];

    },
    filterJustNumber(e){
      const key = e.key;

      if (key === '-'){
        return e.preventDefault();
      }

      if (key === '+'){
        return e.preventDefault();
      }

      // OPTIONAL
      // If is 'e' key, stop it
      if (key === 'e'){
        return e.preventDefault();
      }

    },

    bloquearMasDeDosDecimales(e) {
      const el = e.target;
      const val = String(el.value || '').replace(',', '.');
      const key = e.key;

      // Teclas de control permitidas
      if (['Backspace','Delete','ArrowLeft','ArrowRight','Tab','Home','End'].includes(key)) return;

      // Punto decimal: solo uno (a menos que esté seleccionando y reemplace)
      if (key === '.') {
        const sel = el.selectionStart !== el.selectionEnd;
        if (val.includes('.') && !sel) e.preventDefault();
        return;
      }

      // Solo dígitos
      if (!/^\d$/.test(key)) { e.preventDefault(); return; }

      // Regla de 2 decimales (si ya hay punto y no hay selección que vaya a reemplazar)
      const dot = val.indexOf('.');
      if (dot !== -1) {
        const selStart = el.selectionStart;
        const selEnd = el.selectionEnd;
        const replacing = selStart !== selEnd; // hay selección

        // dígito tecleado después del punto y ya hay 2 decimales
        const decs = val.length - dot - 1;
        const caretAfterDot = selStart > dot;

        if (caretAfterDot && decs >= 2 && !replacing) {
          e.preventDefault();
        }
      }
    },

    pegarDecimal2(e) {
      const el = e.target;
      const before = String(el.value || '');
      const paste = (e.clipboardData || window.clipboardData).getData('text');

      // Construir cómo quedaría el valor al pegar en la posición actual
      const start = el.selectionStart;
      const end   = el.selectionEnd;
      let next = before.slice(0, start) + paste + before.slice(end);

      // Normalizar y sanear
      next = next.replace(',', '.').replace(/[^0-9.]/g, '');
      // Dejar un solo punto
      const firstDot = next.indexOf('.');
      if (firstDot !== -1) {
        next = next.slice(0, firstDot + 1) + next.slice(firstDot + 1).replace(/\./g, '');
        // Máximo 2 decimales
        const [ent, dec=''] = next.split('.');
        next = ent + '.' + dec.slice(0, 2);
      }
      if (next.startsWith('.')) next = '0' + next;

      // Aplicar y posicionar caret al final del pegado
      this.productoSeleccionado.precio = next;
      this.$nextTick(() => {
        const newPosBase = start + paste.length;
        // Limitar dentro del largo actual
        const newPos = Math.min(next.length, newPosBase);
        el.setSelectionRange(newPos, newPos);
      });
    },

    formatear2Decimales() {
      const v = this.productoSeleccionado.precio;
      if (v == null || v === '') return;
      const n = Number(String(v).replace(',', '.'));
      if (isNaN(n)) { this.productoSeleccionado.precio = ''; return; }
      this.productoSeleccionado.precio = n.toFixed(2);
    },

  },
}
</script>

<style scoped>
.busqueda {
  border-width: 1px;
  border-style: solid;
  border-color: #c2e7ff;
  background: #ffffff;
  margin-top: 20px;
  margin-left: 4%;
  padding-right: 2%;
  padding-left: 1%;
  border-radius: 20px;
  text-align: left;
  align-items: center;
}
.fontsPeque {
  font-size: 10px;
}
.tabTxtSeleccionado {
  font-size: 80%;
  color: #17a2b8;
  width: 100%;
}

.tamanioCampo {
  width: 94%;
}
.tabTxt {
  font-size: 75%;
  color: #717171;
}

.tabOpciones.seleccionado {
  border-style: solid;
  border-width: 1px;
  border-color: #90d3dd;
  border-radius: 10px;
  color: #17a2b8;
}

.tabOpciones:hover {
  font-weight: 600;
}

.tabs {
  position: relative;
  width: 100%;
}

.tabs .tabs-nav ul {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
}

.tabs .tabs-nav ul li {
  flex: 1 0 auto;
  margin: 0;
  border-bottom: 3px solid transparent;
}

.tabs .tabs-nav ul li a {
  display: block;
  padding: 0.4em 2em 0.4em 2em;
  border: none;
  color: #aaaaaa;
}

.tabs .tabs-nav ul li a:hover {
  /* al sobre poner el mouse */
  color: #369bda;
}

.border {
  /* borde inferior */
  border-bottom: 3px solid #0069a9;
  width: 20%;
}

.tabs .tabs-nav ul li.active a {
  color: #0069a9;
  font-weight: 600;
}

.tabs .tabs-content {
  width: 100%;
}

</style>